import { message } from 'antd';

// eslint-disable-next-line import/prefer-default-export
export const onRemoveTeamMemberHandler = async (params) => {
  const { removeTeamMember, teamId, userId, onCancel, refetchMemberList } =
    params;

  try {
    await removeTeamMember({
      variables: {
        team_id: teamId,
        user_id: userId,
      },
    });
    message.success('Succesful remove member');
    refetchMemberList();
    onCancel();
  } catch {
    message.error('Unsuccesful remove member ');
  }
};
